/**
 * UI copy for dashboard shell + lesson reader chrome (EN / SI / TA).
 * Lesson body text comes from published lesson fields, not here.
 */

const en = {
  'nav.dashboard': 'Dashboard',
  'nav.profile': 'Profile',
  'nav.users': 'Users',
  'nav.courses': 'Courses',
  'nav.enrollments': 'Enrollments',
  'nav.lessonPlanner': 'Lesson Planner',
  'nav.instructors': 'Instructors',
  'nav.staff': 'Staff',
  'nav.students': 'Students',
  'nav.verifications': 'Verifications',
  'nav.payments': 'Payments',
  'nav.settings': 'Settings',
  'nav.myStudents': 'My Students',
  'nav.schedule': 'Schedule',
  'nav.myCourses': 'My Courses',
  'nav.availableCourses': 'Available Courses',
  'nav.classSchedule': 'Class Schedule',
  'nav.assignments': 'Assignments',
  'nav.grades': 'Grades',
  'nav.attendance': 'Attendance',
  'nav.publicWebsite': 'Public Website',
  'header.openSidebar': 'Open sidebar',
  'header.logout': 'Log out',
  'lang.label': 'Language',
  'lang.en': 'English',
  'lang.si': 'සිංහල',
  'lang.ta': 'தமிழ்',
  'reader.backMyCourse': 'Back to my course',
  'reader.backCourse': 'Back to course',
  'reader.previewAdmin': 'Preview as admin (includes staff-only notes)',
  'reader.cardSession': 'This session',
  'reader.sessionOf': 'Session {{n}} of {{total}}',
  'reader.progressTitle': 'Your progress',
  'reader.progressLine': '{{done}} / {{total}} sessions marked done',
  'reader.onThisPage': 'On this page',
  'reader.allSessions': 'All sessions',
  'reader.here': 'Here',
  'reader.resources': 'Resources',
  'reader.watchVideo': 'Watch video',
  'reader.assignmentFile': 'Assignment file',
  'reader.tutorialLink': 'Tutorial',
  'reader.previous': 'Previous',
  'reader.next': 'Next',
  'reader.markComplete': 'Mark complete',
  'reader.completed': 'Completed',
  'reader.enrollmentRequired':
    'You need an active enrollment to open this lesson reader.',
  'reader.notFound': 'This lesson could not be found in the course.',
  'reader.emptyBody':
    'Detailed session write-up is not available for this lesson yet. Check Resources below, or ask your tutor.',
  'reader.switchCourse': 'Switch course',
  'reader.tutorialRibbon': 'Lesson tutorial',
  'reader.beforeYouBegin': 'Before you begin',
  'reader.wrapUp': 'Wrap-up & next steps',
  'reader.sectionN': 'Part {{n}}',
  'reader.facilitatorOutline': 'Facilitator outline & logistics',
  'reader.facilitatorHint':
    'Timing, setup, and delivery notes below. Learners follow the tutorial above.',
  'reader.aboutSession': 'About this session',
  'reader.whatYouCover': 'What you’ll cover',
  'reader.learningOutcomes': 'Learning outcomes (reference)',
  'reader.sessionFlow': 'How the session flows',
  'reader.materials': 'What you’ll need',
  'reader.activities': 'Activities & practice',
  'reader.safety': 'Safety & hygiene',
  'reader.assessment': 'How you’ll be assessed',
  'reader.afterSession': 'After the session',
  'reader.tutorNotes': 'Tutor notes (staff only)',
  'reader.furtherReading': 'Further reading',
  'reader.instructions': 'Instructions',
  'reader.deliverables': 'Deliverables',
  'reader.rubric': 'Rubric',
  'reader.lessonVideo': 'Lesson video',
  'reader.sessionVideos': 'Videos',
  'reader.sessionAttachments': 'Downloads & links',
  'reader.openAttachment': 'Open',
};

const si = {
  ...en,
  'nav.dashboard': 'ඩෑෂ්බෝඩ්',
  'nav.profile': 'පැතිකඩ',
  'nav.users': 'පරිශීලකයන්',
  'nav.courses': 'පාඨමාලා',
  'nav.enrollments': 'ලියාපදිංචි',
  'nav.lessonPlanner': 'Lesson Planner',
  'nav.instructors': 'උපදේශකවරු',
  'nav.staff': 'Staff',
  'nav.students': 'ශිෂ්‍යයන්',
  'nav.verifications': 'සත්‍යාපනය',
  'nav.payments': 'ගෙවීම්',
  'nav.settings': 'සැකසුම්',
  'nav.myStudents': 'මගේ ශිෂ්‍යයන්',
  'nav.schedule': 'කාලසටහන',
  'nav.myCourses': 'මගේ පාඨමාලා',
  'nav.availableCourses': 'ලබා ගත හැකි පාඨමාලා',
  'nav.classSchedule': 'පන්ති කාලසටහන',
  'nav.assignments': 'වැඩ',
  'nav.grades': 'ලකුණු',
  'nav.attendance': 'පැමිණීම',
  'nav.publicWebsite': 'වෙබ් අඩවිය',
  'header.openSidebar': 'මෙනුව විවෘත කරන්න',
  'header.logout': 'ඉවත් වන්න',
  'lang.label': 'භාෂාව',
  'reader.backMyCourse': 'මගේ පාඨමාලාවට ආපසු',
  'reader.backCourse': 'පාඨමාලාවට ආපසු',
  'reader.previewAdmin': 'Admin පෙන්වීම (staff notes ඇතුළත්)',
  'reader.cardSession': 'මෙම සෙෂනය',
  'reader.sessionOf': 'සෙෂනය {{n}} / {{total}}',
  'reader.progressTitle': 'ඔබේ ප්‍රගතිය',
  'reader.progressLine': 'සම්පූර්ණ කළ සෙෂන් {{done}} / {{total}}',
  'reader.onThisPage': 'මෙම පිටුවේ',
  'reader.allSessions': 'සියලු සෙෂන්',
  'reader.here': 'මෙතන',
  'reader.resources': 'සම්පත්',
  'reader.watchVideo': 'වීඩියෝව බලන්න',
  'reader.assignmentFile': 'Assignment ලිපිගොනුව',
  'reader.tutorialLink': 'Tutorial',
  'reader.previous': 'පෙර',
  'reader.next': 'ඊළඟ',
  'reader.markComplete': 'සම්පූර්ණයි ලකුණු කරන්න',
  'reader.completed': 'සම්පූර්ණයි',
  'reader.enrollmentRequired':
    'lesson reader එක විවෘත කිරීමට සක්‍රිය enrollment එකක් ඕනෑ.',
  'reader.notFound': 'මෙම පාඩම පාඨමාලාවේ හමු නොවීය.',
  'reader.emptyBody':
    'විස්තරාත්මක අන්තර්ගතය තවම නැහැ. Resources බලන්න, හෝ tutorගෙන් අසන්න.',
  'reader.switchCourse': 'පාඨමාලාව මාරු කරන්න',
  'reader.tutorialRibbon': 'පාඩම් tutorial',
  'reader.beforeYouBegin': 'ආරම්භ කිරීමට පෙර',
  'reader.wrapUp': 'සාරාංශය & ඊළඟ පියවර',
  'reader.sectionN': 'කොටස {{n}}',
  'reader.facilitatorOutline': 'Facilitator සැලසුම & logistics',
  'reader.facilitatorHint':
    'කාලය, setup, බෙදා හැරීමේ notes පහළින්. learners ඉහළ tutorial එක අනුගමන කරයි.',
  'reader.aboutSession': 'මෙම සෙෂනය ගැන',
  'reader.whatYouCover': 'ආවරණය කරන දේ',
  'reader.learningOutcomes': 'ඉගෙනුම් ප්‍රතිඵල (reference)',
  'reader.sessionFlow': 'සෙෂනය ගලා යන ආකාරය',
  'reader.materials': 'අවශ්‍ය දේ',
  'reader.activities': 'ක්‍රියාකාරකම් & practice',
  'reader.safety': 'ආරක්ෂාව & හයිජීනය',
  'reader.assessment': 'අගය කිරීම',
  'reader.afterSession': 'සෙෂනයෙන් පසු',
  'reader.tutorNotes': 'Tutor notes (staff only)',
  'reader.furtherReading': 'තව කියවීමට',
  'reader.instructions': 'උපදෙස්',
  'reader.deliverables': 'ඉදිරිපත් කිරීම්',
  'reader.rubric': 'Rubric',
  'reader.lessonVideo': 'පාඩම් වීඩියෝව',
  'reader.sessionVideos': 'වීඩියෝ',
  'reader.sessionAttachments': 'බාගත කිරීම් සහ ලින්ක්',
  'reader.openAttachment': 'විවෘත කරන්න',
};

const ta = {
  ...en,
  'nav.dashboard': 'டாஷ்போர்டு',
  'nav.profile': 'சுயவிவரம்',
  'nav.users': 'பயனர்கள்',
  'nav.courses': 'பாடநெறிகள்',
  'nav.enrollments': 'பதிவுகள்',
  'nav.lessonPlanner': 'Lesson Planner',
  'nav.instructors': 'ஆசிரியர்கள்',
  'nav.staff': 'Staff',
  'nav.students': 'மாணவர்கள்',
  'nav.verifications': 'சரிபார்ப்பு',
  'nav.payments': 'கட்டணங்கள்',
  'nav.settings': 'அமைப்புகள்',
  'nav.myStudents': 'என் மாணவர்கள்',
  'nav.schedule': 'அட்டவணை',
  'nav.myCourses': 'என் பாடநெறிகள்',
  'nav.availableCourses': 'கிடைக்கும் பாடநெறிகள்',
  'nav.classSchedule': 'வகுப்பு அட்டவணை',
  'nav.assignments': 'பணிகள்',
  'nav.grades': 'மதிப்பெண்கள்',
  'nav.attendance': 'வருகை',
  'nav.publicWebsite': 'வலைத்தளம்',
  'header.openSidebar': 'பட்டியலைத் திற',
  'header.logout': 'வெளியேறு',
  'lang.label': 'மொழி',
  'reader.backMyCourse': 'என் பாடத்திற்குத் திரும்பு',
  'reader.backCourse': 'பாடத்திற்குத் திரும்பு',
  'reader.previewAdmin': 'Admin முன்னோட்டம் (staff குறிப்புகள்)',
  'reader.cardSession': 'இந்த அமர்வு',
  'reader.sessionOf': 'அமர்வு {{n}} / {{total}}',
  'reader.progressTitle': 'உங்கள் முன்னேற்றம்',
  'reader.progressLine': 'முடித்த அமர்வுகள் {{done}} / {{total}}',
  'reader.onThisPage': 'இப்பக்கத்தில்',
  'reader.allSessions': 'அனைத்து அமர்வுகள்',
  'reader.here': 'இங்கே',
  'reader.resources': 'வளங்கள்',
  'reader.watchVideo': 'வீடியோ பார்',
  'reader.assignmentFile': 'Assignment கோப்பு',
  'reader.tutorialLink': 'Tutorial',
  'reader.previous': 'முந்தைய',
  'reader.next': 'அடுத்து',
  'reader.markComplete': 'முடிந்தது எனக் குறி',
  'reader.completed': 'முடிந்தது',
  'reader.enrollmentRequired': 'இந்த reader திறக்க செயலில் உள்ள பதிவு தேவை.',
  'reader.notFound': 'இந்த பாடம் பாடநெறியில் இல்லை.',
  'reader.emptyBody':
    'விரிவான உள்ளடக்கம் இன்னும் இல்லை. Resources பாருங்கள் அல்லது tutor-ஐக் கேளுங்கள்.',
  'reader.switchCourse': 'பாடநெறியை மாற்று',
  'reader.tutorialRibbon': 'பாட tutorial',
  'reader.beforeYouBegin': 'தொடங்குவதற்கு முன்',
  'reader.wrapUp': 'சுருக்கம் & அடுத்த படிகள்',
  'reader.sectionN': 'பகுதி {{n}}',
  'reader.facilitatorOutline': 'Facilitator திட்டம் & logistics',
  'reader.facilitatorHint':
    'நேரம், setup, வழங்கல் குறிப்புகள் கீழே. learners மேலே உள்ள tutorial-ஐப் பின்பற்றுகிறார்கள்.',
  'reader.aboutSession': 'இந்த அமர்வு பற்றி',
  'reader.whatYouCover': 'நீங்கள் கற்கும் விஷயம்',
  'reader.learningOutcomes': 'கற்றல் முடிவுகள் (குறிப்பு)',
  'reader.sessionFlow': 'அமர்வு ஓட்டம்',
  'reader.materials': 'தேவையானவை',
  'reader.activities': 'செயல்பாடுகள் & practice',
  'reader.safety': 'பாதுகாப்பு & சுகாதாரம்',
  'reader.assessment': 'மதிப்பீடு',
  'reader.afterSession': 'அமர்வுக்குப் பிறகு',
  'reader.tutorNotes': 'Tutor குறிப்புகள் (staff only)',
  'reader.furtherReading': 'மேலும் வாசிப்பு',
  'reader.instructions': 'வழிமுறைகள்',
  'reader.deliverables': 'சமர்ப்பிக்க வேண்டியவை',
  'reader.rubric': 'Rubric',
  'reader.lessonVideo': 'பாட வீடியோ',
  'reader.sessionVideos': 'வீடியோக்கள்',
  'reader.sessionAttachments': 'பதிவிறக்கங்கள் & இணைப்புகள்',
  'reader.openAttachment': 'திற',
};

export const UI_STRINGS = { en, si, ta };

export function resolveUiString(strings, lang, key, params) {
  const table = strings[lang] || strings.en;
  let s = table[key] ?? strings.en[key] ?? key;
  if (params && typeof s === 'string') {
    Object.entries(params).forEach(([k, v]) => {
      s = s.replaceAll(`{{${k}}}`, String(v));
    });
  }
  return s;
}
